import { render, staticRenderFns } from "./MixPicklDetails.vue?vue&type=template&id=5befb60c&"
import script from "./MixPicklDetails.vue?vue&type=script&lang=js&"
export * from "./MixPicklDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5befb60c')) {
      api.createRecord('5befb60c', component.options)
    } else {
      api.reload('5befb60c', component.options)
    }
    module.hot.accept("./MixPicklDetails.vue?vue&type=template&id=5befb60c&", function () {
      api.rerender('5befb60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/MixPicklDetails.vue"
export default component.exports